var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"dot-status",class:[_vm.color, _vm.area]})}
var staticRenderFns = []

export { render, staticRenderFns }